module.exports = __webpack_public_path__ + "img/coupon_nine_other.d4760569.webp";